import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductCard from '../CategoryCollectionListDesktop/ProductCard';
import EditPencil from '../../../../../../Assets/StorefrontIcons/EditPencil.svg';
import ArrowUp from '../../../../../../Assets/StorefrontIcons/ArrowUp.svg';
import { moveSectionDown, moveSectionUp, removeSection, setCustomCollectionToEdit, setSectionFormType, setSectionType } from '../../../../../../Features/storefrontSlice';
import { showToast } from '../../../../../../Components/Toaster/Toaster';
import Delete from '../../../../../../Assets/DeleteRed.svg';
import { apiV1 } from '../../../../../../Auth/Interceptor';

function CustomCollectionListDesktop({ item }) {
    const dispatch = useDispatch();

    const [buttonsVisible, setButtonsVisible] = useState(false);
    const [hoverOnBox, setHoverOnBox] = useState(false);

    const [titleTextSize, setTitleTextSize] = useState(0);
    const [titleLineHeight, setTitleLineHeight] = useState(0);

    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);

    const [productsList, setProductsList] = useState([]);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const mobileItem = versionStack[versionIndex]?.versionData.find(section => section.item.name === item.item.name);

    useEffect(() => {
        setTitleTextSize((zoomSize/100)*12);
        setTitleLineHeight((zoomSize/100)*18);

        setTextSize((zoomSize/100)*8.86);
        setLineHeight((zoomSize/100)*15.5);
    }, [zoomSize]);

    useEffect(() => {
        async function fetchCustomCollectionProducts() {
            try {
                const response = await apiV1.get(`customCollection/${item.item.customCollectionList[0]}`);
                if(response.status === 200) {
                    setProductsList(response.data.data.product);
                }
            }
            catch(err) {
                console.log(err);
            }
        }

        item.item.customCollectionList[0] && fetchCustomCollectionProducts();
    }, [item]);

    useEffect(() => {
        if(hoverOnBox) {
            setButtonsVisible(true);
        } else {
            setButtonsVisible(false);
        }
    }, [hoverOnBox]);

    function handleEditClick() {
        dispatch(setCustomCollectionToEdit(item.item.id));
        dispatch(setSectionType('SECTION'));
        dispatch(setSectionFormType('CUSTOM_COLLECTION_LIST_DESKTOP'));
    }
    
    function handleUpClick() {
        if(item.prev) {
            dispatch(moveSectionUp({ item, mobileItem }));
        }
        else {
            showToast('Action failed!', 'warning');
        }
    }

    function handleDownClick() {
        if(item.next) {
            dispatch(moveSectionDown({ item, mobileItem }));
        }
        else {
            showToast('Action failed!', 'warning');
        }
    }

    function handleDeleteClick() {
        dispatch(removeSection({ item, mobileItem }));
    }

    return (
        <div 
            onMouseEnter={() => setHoverOnBox(true)} 
            onMouseLeave={() => setHoverOnBox(false)} 
            className='w-full px-3 flex flex-col gap-2 relative'
        >
            {
                buttonsVisible && 
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 flex items-center rounded-md overflow-hidden bg-[#FFFFFF]">
                    <button onClick={handleEditClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={EditPencil} alt="" />
                    </button>
                    <button onClickCapture={handleUpClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={ArrowUp} alt="" />
                    </button>
                    <button onClick={handleDownClick} className='outline-none size-8 flex items-center justify-center'>
                        <img className='rotate-180' src={ArrowUp} alt="" />
                    </button>
                    <button onClick={handleDeleteClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={Delete} alt="" />
                    </button>
                </div>
            }

            <div className="flex items-center justify-between">
                <p style={{ fontSize: `${titleTextSize}px`, lineHeight: `${titleLineHeight}px` }} className='font-semibold text-[#000000]'>{item.item.name}</p>

                <p style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px` }} className='font-semibold text-[#64DD17]'>See all</p>
            </div>

            <div className="grid grid-cols-5 gap-x-2 gap-y-2">
                {productsList?.slice(0, 10).map(product => {
                    return (
                        <ProductCard 
                            key={product.id} 
                            product={product} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default CustomCollectionListDesktop;
